<!--  -->
<template>
  <div class="intro-form">
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="284">
      <FormItem label="Mentee's Name"
                prop="name">
        <Input v-model.trim="formValidate.name"
               placeholder="e.g. Last Name First Name"></Input>
      </FormItem>
      <FormItem label="Phone"
                prop="phone">
        <Input v-model.trim="formValidate.phone"
               placeholder="e.g. 13512345678"></Input>
      </FormItem>
      <FormItem label="Wechat"
                prop="wechat">
        <Input v-model.trim="formValidate.wechat"
               placeholder="e.g. WeChat_01"></Input>
      </FormItem>
      <FormItem label="Email"
                prop="email">
        <Input v-model.trim="formValidate.email"
               placeholder="e.g. name@gamil.com"></Input>
      </FormItem>
      <FormItem label="University"
                prop="univer">
        <Input v-model.trim="formValidate.univer"
               placeholder="e.g. Peking University"></Input>
      </FormItem>
      <FormItem label="Grade"
                prop="grade">
        <Select v-model="formValidate.grade"
                clearable>
          <Option v-for="(item, index) in gradeMap"
                  :key="index"
                  :value="item.value">{{item.title}}</Option>
        </Select>
      </FormItem>
    </Form>
    <div class="intro-btn">
      <Button class="zlr-btn-primary"
              :loading="isSub"
              @click="handleSub">Submit</Button>
    </div>
  </div>
</template>

<script>
// api
import { subRecommendCreate } from '@/api/recommend'
// constant
import { gradeMap, subSuc } from '@/constant'
// validator
import { validateEmail } from '@/libs/validator'
export default {
  name: 'referral-input',
  components: {},
  props: {
    type: {
      type: String,
      validator (value) {
        return ['CLIENT', 'SCHOLARSHIP'].includes(value)
      }
    }
  },
  data () {
    return {
      gradeMap,
      formValidate: {},
      ruleValidate: {
        name: [{ required: true }],
        email: [{ validator: validateEmail }]
      },
      isSub: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 提交信息
    handleSub () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          data.type = this.type
          this.isSub = true
          subRecommendCreate(data).then(() => {
            this.$zlr_message(subSuc, 'success')
            this.$emit('on-success')
            this.resetData()
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    resetData () {
      this.$refs['formValidate'].resetFields()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
